module.exports = __webpack_public_path__ + "img/green_talk.3e8efab4.gif";